export default __webpack_public_path__ + "d31f7d03ebfa248d3a6e5d62b49eee19.svg";